<template>
    <v-card class="editor pa-0 ma-0 d-flex flex-column" elevation='0'>
        <v-card :disabled="editorDisabled" elevation='0' class="flex-grow-0 flex-shrink-0">
            <div class="form-item form-item-width-1 mt-2">
                <label class="form-item-label py-0 mt-0 mr-0">编号:</label>
                <v-text-field 
                    class="form-item-value py-0 mr-0 readonly_input_item" 								
                    outlined
                    dense 
                    placeholder=""
                    readonly
                    :value="billData.id==-1?'':billData.id"
                >
                </v-text-field>	
            </div>

            <div class='dash-line'></div>

            <div class="d-flex flex-row mt-2">
                <div class="form-item form-item-width-2">
                    <label class="form-item-label py-0 mt-0 mr-0">门店:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""            
                        v-model="billData.shopName"
                    >
                    </v-text-field>	
                </div>
                
                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">收款台:</label>
                        <v-text-field 
                            class="form-item-value py-0 mr-0 readonly_input_item" 								
                            outlined
                            dense 
                            placeholder=""   
                            readonly                                 
                            v-model="billData.sktno"
                        >
                        </v-text-field>	
                </div>

                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">小票号:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""   
                        readonly                                 
                        v-model="billData.fphm"
                    >
                    </v-text-field>	
                </div>

            </div>

            <div class="d-flex flex-row mt-2">
                <div class="form-item form-item-width-2">
                    <label class="form-item-label py-0 mt-0 mr-0">交易时间:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""   
                        readonly                                 
                        v-model="billData.saleTime"
                    >
                    </v-text-field>	
                </div>

                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">已生成券:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""   
                        readonly                                 
                        :value="givedName"
                    >
                    </v-text-field>	
                </div>

            </div>
            
        </v-card>

        <div class="flex-grow-1 flex-shrink-1 pa-0 ma-0 mt-3">
            <div class="d-flex flex-column  tabPane-root">
                <div class="flex-grow-0 flex-shrink-0 px-1">
                    <v-tabs
                        background-color="transparent"		    
                        left
                        show-arrows			
                        slider-color="transparent"
                        slider-size=0
                        v-model="selectedTabId"
                    >							

                        <v-tab
                            v-for="item in tabs"
					        :key="item.tabId"										
                            active-class="active-tab"
                            :href="'#'+item.tabId"										
                        >										
                            {{ item.title }}
                        </v-tab>
            
                    </v-tabs>	
                </div>
                
                <div class="flex-grow-1 flex-shrink-1 pa-0 v-tabitem-group" style="position:relative;">
                    <div style="position:absolute;top:0;bottom:0;left:0;right:0;">									
                        <div class="ma-0 pa-0"  style="position:relative;width:100%;height:100%;max-width:100%;max-height:100%" >
                            <v-tabs-items v-model="selectedTabId" class="active-tab-view my-0">
                                <v-tab-item												
                                    :key="tabs[0].tabId"	
                                    :value="tabs[0].tabId"	
                                    active-class="active-tab-view"		
                                    eager												
                                >																							
                                    <div  class="mx-0 px-0 my-0"  style="position:relative;width:100%;height:100%;">
                                        <div class="queryResultPaneRoot">
                                            <v-data-table :headers="saleListHeaders"  fixed-header :items="billData.saleGoodss" 
                                                class="elevation-0 result-table ma-0 pa-0"
                                                width="100%" 
                                                height="100%"
                                                :hide-default-footer='true'
                                                :disable-pagination='true'                                               
                                            >
                                            </v-data-table>
                                        </div>
                                    </div>
                                </v-tab-item>
                                
                                <v-tab-item
                                    :key="tabs[1].tabId"	
                                    :value="tabs[1].tabId"	
                                    active-class="active-tab-view"
                                    eager												
                                >											
                                    <div  class="mx-0 px-0 my-0">
                                        <v-data-table :headers="payListHeaders"  fixed-header :items="billData.salePays" class="elevation-0 result-table"
                                            width="100%"
                                            :calculate-widths='false'
                                            :hide-default-footer='true'
                                            :disable-pagination='true'
                                        >
                                        </v-data-table>
                                    </div>
                                </v-tab-item>

                                <v-tab-item
                                    :key="tabs[2].tabId"	
                                    :value="tabs[2].tabId"	
                                    active-class="active-tab-view"
                                    eager												
                                >											
                                    <div  class="mx-0 px-0 my-0">
                                        <v-data-table :headers="giveCouponRecordHeaders"  fixed-header :items="billData.giveCoupons" class="elevation-0 result-table"
                                            width="100%" single-select item-key='couponNo' 
                                            :hide-default-footer='true'
                                            :disable-pagination='true'
                                        >
                                        </v-data-table>
                                    </div>
                                </v-tab-item>

                                <v-tab-item
                                    :key="tabs[3].tabId"	
                                    :value="tabs[3].tabId"	
                                    active-class="active-tab-view"
                                    eager												
                                >											
                                    <div  class="mx-0 px-0 my-0">
                                        <v-data-table :headers="couponActivityHeaders"  fixed-header :items="billData.couponActivitys" class="elevation-0 result-table"
                                            width="100%"
                                            item-key="activityId"
                                            :calculate-widths='false'
                                            :hide-default-footer='true'
                                            :disable-pagination='true'
                                        >
                                        </v-data-table>
                                    </div>
                                </v-tab-item>

                              <v-tab-item
                                  :key="tabs[4].tabId"
                                  :value="tabs[4].tabId"
                                  active-class="active-tab-view"
                                  eager
                              >
                                <div  class="mx-0 px-0 my-0">
                                  <v-data-table :headers="giveStampRecordHeaders" fixed-header :items="billData.giveStamps"  
                                                class="elevation-0 result-table"
                                                width="100%"
                                                item-key="activityId"
                                                :calculate-widths='false'
                                                :hide-default-footer='true'
                                                :disable-pagination='true'
                                  >
                                    <template v-slot:item.status="{item}">
                                        {{['待兑换','已兑换','失效'][item.status - 1]}}
                                    </template>
                                  </v-data-table>
                                </div>
                              </v-tab-item>

                              <v-tab-item
                                  :key="tabs[5].tabId"
                                  :value="tabs[5].tabId"
                                  active-class="active-tab-view"
                                  eager
                              >
                                <div  class="mx-0 px-0 my-0">
                                  <v-data-table :headers="stampActivityHeaders" fixed-header :items="billData.stampActivitys"  class="elevation-0 result-table"
                                                 width="100%"
                                                 item-key="activityId"
                                                 :calculate-widths='false'
                                                 :hide-default-footer='true'
                                                 :disable-pagination='true'
                                  >
                                  </v-data-table>
                                </div>
                              </v-tab-item>
                                
                            </v-tabs-items>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class='dash-line'></div>

        <div class="d-flex flex-row mt-2">
                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">操作员:</label>
                    <v-text-field 
                        class="form-item-value py-2 mr-0 pl-2" 								
                        readonly
                        placeholder=""            
                        v-model="billData.operName"
                    >
                    </v-text-field>	
                </div>
                
                <div class="form-item form-item-width-2">
                    <label class="form-item-label py-0 mt-0 mr-0">保存时间:</label>
                    <v-text-field 
                        class="form-item-value py-2 mr-0 pl-2" 								
                        placeholder=""   
                        readonly                                 
                        v-model="billData.createTime"
                    >
                    </v-text-field>	
                </div>    

            </div>

        <TicketSelectDialog
            ref="ticketSelectDialog"
            @loadSaleCouponInfoRequested="loadSaleCouponInfoRequested"
        />

        <ActivitySelectDialog
            ref="selectActivityDialog"
            @couponActivitySelected="couponActivitySelected"
        />

    </v-card>
</template>

<script>
    import EditorState from '../../../../base/bill/EditorState.js';
    import CouponActivityRecordApi from '../../../../../api/sm/market/printcoupon/CouponActivityRecordApi.js';
    import SaleHeadApi from '../../../../../api/sm/jg/sale/SaleHeadApi.js';
    import TicketSelectDialog from './TicketSelectDialog.vue';
    import ActivitySelectDialog from '../activity/ActivitySelectDialog.vue';
    import BackendPrintApi from "../../../../../api/sm/market/printcoupon/BackendPrintApi.js";
    import CouponActivityApi from "../../../../../api/sm/market/printcoupon/CouponActivityApi.js";

import { setTimeout } from 'timers';

    export default {
        name:'Sm-Market-Printcoupon-Backend-Print-Editor',
        props:['context'],
        components:{
            'TicketSelectDialog':TicketSelectDialog,
            'ActivitySelectDialog':ActivitySelectDialog,
        },
        data () {
            return {
                selectedTabId:'tab-1',
                printing:false,

                billData:{
                    saleHead:null,
                    saleGoodss:[],
                    salePays:[],
                    giveCoupons:[],
                    couponActivitys:[],
                    giveStamps:[],
                    stampActivitys:[],

                    id:-1,
                    shopId:'',
                    shopName:'',
                    sktno:'',
                    fphm:'',
                    operId:-1,
                    operName:'',
                    createTime:'',
                    saleTime:'',
                    gived:0,

                },
                editorState:EditorState.BROWSING,

                tabs:[
                  {tabId:'tab-1',title:'POS交易商品明细'},
                  {tabId:'tab-2',title:'POS交易收款方式'},
                  {tabId:'tab-3',title:'营销赠送打印券'},
                  {tabId:'tab-4',title:'赠券营销活动'},
                  {tabId:'tab-5',title:'营销赠送印花券'},
                  {tabId:'tab-6',title:'赠送印花券活动'},
                ],

                saleListHeaders:[
                    {text: '交易号',value: 'billNo',sortable: false,width: 150,divider: true},
                    {text: '商品号',value: 'goodsId',sortable: false,width: 160,divider: true},
                    {text: '商品条码',value: 'barcode',sortable: false,width: 180,divider: true},
                    {text: '商品名',value: 'goodsName',sortable: false,width: 260,divider: true},
                    {text: '商品数量',value: 'qty',sortable: false,width: 100,divider: true},
                    {text: '成交金额',value: 'amount',sortable: false,width: 150,divider: true},
                    {text: '分类号',value: 'categoryId',sortable: false,width: 120,divider: true},
                    {text: '',value: '',sortable: false,divider: false},
                ],
                payListHeaders:[
                    {text: '交易号',value: 'billNo',sortable: false,width: 150,divider: true},
                    {text: '支付方式代码',value: 'payCode',sortable: false,width: 120,divider: true},
                    {text: '支付方式名称',value: 'payName',sortable: false,width: 120,divider: true},
                    {text: '成交金额',value: 'amount',sortable: false,width: 100,divider: true},
                    {text: '支付方式类型',value: 'flagName',sortable: false,width: 120,divider: true},
                    {text: '单号',value: 'payNo',sortable: false,width: 120,divider: true},
                    {text: '',value: '',sortable: false,divider: false},
                ],

                giveCouponRecordHeaders: [
                    {text: '门店',value: 'shopName',sortable: false,width: 80,divider: true},
                    {text: '款台号',align: 'center',sortable: false,value: 'sktNo',width: 80,divider: true},
                    {text: '发票号码',align: 'center',sortable: false,value: 'fphm',width: 80,divider: true},
                    {text: '交易时间',align: 'start',sortable: false,value: 'saleTime',width: 120,divider: true},
                    {text: '有效交易金额',align: 'start',sortable: false,value: 'orderAmount',width: 120,divider: true},
                    {text: '券创建时间',align: 'start',sortable: false,value: 'createTime',width: 120,divider: true},
                    {text: '券号',align: 'start',sortable: false,value: 'couponNo',width: 200,divider: true},
                    {text: '券名',align: 'start',sortable: false,value: 'couponName',width: 120,divider: true},
                    {text: '券面值',align: 'start',sortable: false,value: 'couponAmount',width: 120,divider: true},
                    {text: '券余额',align: 'start',sortable: false,value: 'leftAmount',width: 120,divider: true},


                    {text: '有效期开始时间',align: 'start',sortable: false,value: 'beginDate',width: 120,divider: true},
                    {text: '有效期结束时间',align: 'start',sortable: false,value: 'endDate',width: 120,divider: true},

                ],

                couponActivityHeaders:[
                    {text: '活动号',value: 'activityId',sortable: false,width: 80,divider: true},
                    {text: '活动名',value: 'activityName',sortable: false,width: 160,divider: true},
                    {text: '券编号',value: 'couponId',sortable: false,width: 80,divider: true},
                    {text: '券名称',value: 'couponName',sortable: false,width: 220,divider: true},
                    {text: '开始日期',value: 'startDate',sortable: false,width: 200,divider: true},
                    {text: '结束日期',value: 'endDate',sortable: false,width: 200,divider: true},
                    {text: '消费金额',value: 'sharpAmount',sortable: false,width: 100,divider: true},
                    {text: '送券金额',value: 'couponAmount',sortable: false,width: 100,divider: true},
                    {text: '单笔最多送券金额',value: 'maxAmount',sortable: false,width: 100,divider: true},
                    {text: '每天最多送券金额',value: 'dayMaxAmount',sortable: false,width: 100,divider: true},
                    {text: '周几',value: 'weekDay',width: 40,sortable: false,divider: false},
                ],

              giveStampRecordHeaders: [
                {text: '门店',value: 'shopName',sortable: false,width: 80,divider: true},
                {text: '款台号',align: 'center',sortable: false,value: 'sktNo',width: 80,divider: true},
                {text: '发票号码',align: 'center',sortable: false,value: 'fphm',width: 80,divider: true},
                {text: '交易时间',align: 'start',sortable: false,value: 'saleTime',width: 120,divider: true},
                {text: '有效交易金额',align: 'start',sortable: false,value: 'orderAmount',width: 120,divider: true},
                {text: '券创建时间',align: 'start',sortable: false,value: 'createTime',width: 120,divider: true},
                {text: '券号',align: 'start',sortable: false,value: 'stampNo',width: 200,divider: true},
                {text: '券名',align: 'start',sortable: false,value: 'stampName',width: 120,divider: true},
                {text: '印花数',align: 'start',sortable: false,value: 'stampNum',width: 120,divider: true},
                {text: '券状态',align: 'start',sortable: false,value: 'status',width: 120,divider: true},
                {text: '有效期开始时间',align: 'start',sortable: false,value: 'exchangeStartDate',width: 120,divider: true},
                {text: '有效期结束时间',align: 'start',sortable: false,value: 'exchangeEndDate',width: 120,divider: true},

              ],

              stampActivityHeaders:[
                {text: '活动号',value: 'activityId',sortable: false,width: 80,divider: true},
                {text: '活动名',value: 'activityName',sortable: false,width: 160,divider: true},
                {text: '开始日期',value: 'startDate',sortable: false,width: 200,divider: true},
                {text: '结束日期',value: 'endDate',sortable: false,width: 200,divider: true},
                {text: '消费金额',value: 'sharpAmount',sortable: false,width: 100,divider: true},
                {text: '印花数',value: 'stampNum',sortable: false,width: 100,divider: true},
                {text: '单笔最多印花数',value: 'maxStampNum',sortable: false,width: 100,divider: true},
              ],
            }
        },
        computed:{ 
            editorDisabled(){
                console.log("editorDisabled");
                return (this.editorState!=EditorState.EDITING);
            },
          givedName:function(){
            if(this.billData){
              if(this.billData.gived==0)
                return "未生成券";
              else if(this.billData.gived==1)
                return "已生成券";
              return "";
            }
            return "";
          },
        },
        methods:{
            getContext(){
                return this.context;
            },

            getBill(){
                return this.getContext().bill;
            },
            getMessageDialogHelper(){
                return  this.getContext().messageDialogHelper;
            },
            getBillData(){
                return this.billData;
            },
            getBillId(){
                return this.billData.billId;
            },
            getSignals () {
                return this.context.signals;
            },

            initSignals(){
                if(!this.signalInited){
                    this.initCustomCommandAction();
                    this.signalInited = true;
                }
            },
            loadTicketAction(){
                let me = this;
                let dialog = me.$refs.ticketSelectDialog;
                console.log('loadTicketAction');
                console.log(me);
                console.log(dialog);
                if(dialog){
                    dialog.clear();
                    dialog.setVisible(true);
                }
            },
            initCustomCommandAction () {
                let me = this;
                let signal = null;
                signal = this.getSignals().customCommandAsked;
                signal.add(function (param) {
                    if(param.command=="LOAD_TICKET"){
                        me.loadTicketAction();
                    }else if(param.command=="SELECT_ACTIVITY"){
                        me.selectActivityAction();
                    }else if(param.command=="PRINT_COUPON"){
                        me.printCouponAction();
                    }
                });
            },

            selectSaleGoodsTab(){
                this.selectedTabId=this.tabs[0].tabId;
            },
            selectGiveCouponTab(){
                this.selectedTabId=this.tabs[2].tabId;
            },
            selectCouponActivityTab(){
                this.selectedTabId=this.tabs[3].tabId;
            },

            reload(printId){
                let me = this;
                let signal = null;
                signal = this.getSignals().browseBillAsked;
                signal.dispatch({id:printId});
            },

            async loadSaleCouponInfoRequested(params){                
                let me = this;
                
                try{

                    let saleHead = await this.loadSaleHeadRemote(params);
                    this.billData.saleHead = saleHead;
                    this.billData.saleGoodss = saleHead.saleGoodss;
                    this.billData.salePays = saleHead.salePays;

                    this.billData.shopId = saleHead.shopId;
                    this.billData.shopName = saleHead.shopName;
                    this.billData.sktno = saleHead.posNo;
                    this.billData.fphm = saleHead.listNo;
                    this.billData.saleTime = saleHead.saleDate;

                    let couponActivityRecords = await this.loadCouponActivityRecordsRemote(params);
                    this.billData.giveCoupons = couponActivityRecords;

                    let couponStampRecords = await this.loadCouponStampRecordsRemote(params);
                    this.billData.giveStamps = couponStampRecords;

                    
                    if(couponActivityRecords && couponActivityRecords.length && couponActivityRecords.length>0){
                        this.billData.gived=1;
                    }else{
                        this.billData.gived=0;
                    }

                    //自动加载门店券活动
                    let selectdActivitys = await this.loadShopCouponActivitysRemote();
                    this.billData.couponActivitys = selectdActivitys;

                    let stampActivitys = await this.loadShopStampActivitysRemote();
                    this.billData.stampActivitys = stampActivitys;

                    this.selectSaleGoodsTab();
                }catch(err){
                    me.getMessageDialogHelper().errMsg('错误','加载交易和送券信息失败:'+err.message);
                    return;
                }
                //return user;
            },

            async loadShopCouponActivitysRemote(){
                let me = this;
                let params={ shopId:me.billData.shopId, saleDate:me.billData.saleTime };
                let queryCouponActivityResp = await CouponActivityApi.queryCouponActivity(params);
                console.log("load coupon activity returned;");

                console.log(queryCouponActivityResp);
                
                let data = queryCouponActivityResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取打印送券活动失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.couponActivitys)){
                    throw new Error('获取打印送券活动失败(无会话数据)');
                    return;
                }
                
               return data.data.couponActivitys;
            },

          async loadShopStampActivitysRemote(){
            let me = this;
            let params={ shopId:me.billData.shopId, saleDate:me.billData.saleTime };
            let queryStampActivityResp = await CouponActivityApi.queryStampActivity(params);
            console.log("load stamp activity returned;");

            console.log(queryStampActivityResp);

            let data = queryStampActivityResp.data;
            if((!data)||(!(data.code))||(data.code!=200)){
              let msg=data.msg;
              msg = ((!msg)||(msg==''))?'获取打印送印花券活动失败':msg;
              throw new Error(msg);
              return;
            }

            return data.data.list;
          },

            async loadCouponActivityRecordsRemote(params){
                let me = this;
                let queryGiveCoupinResp = await CouponActivityRecordApi.queryGivePrintCoupons(params);
                console.log("queryGiveCoupon returned;");

                console.log(queryGiveCoupinResp);
                
                let data = queryGiveCoupinResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取发券信息失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.couponActivityRecords)){
                    throw new Error('获取发券信息失败(无会话数据)');
                    return;
                }
                let couponActivityRecords = data.data.couponActivityRecords;
                return couponActivityRecords;
            },
          async loadCouponStampRecordsRemote(params){
            let me = this;
            let queryGiveCoupinResp = await CouponActivityRecordApi.queryGiveStampCoupons(params);
            console.log("queryGiveCoupon returned;");

            console.log(queryGiveCoupinResp);

            let data = queryGiveCoupinResp.data;
            if((!data)||(!(data.code))||(data.code!=200)){
              let msg=data.msg;
              msg = ((!msg)||(msg==''))?'获取印花券券信息失败':msg;
              throw new Error(msg);
              return;
            }
            let couponActivityRecords = data.data.list;
            return couponActivityRecords;
          },
            async loadSaleHeadRemote(params){
                let me = this;
                let getSaleHeadResp = await SaleHeadApi.getSaleHead(params);
                console.log("getSaleHead  returned;");

                console.log(getSaleHeadResp);
                
                let data = getSaleHeadResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取POS交易失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.saleHead)){
                    throw new Error('获取POS交易信息失败(无会话数据)');
                    return;
                }
                let saleHead = data.data.saleHead;
                
                this.checkSaleHeadData(saleHead);
                return saleHead;
            },
            checkSaleHeadData(saleHead){

            },

            selectActivityAction(){
                let me = this;
                let dialog = me.$refs.selectActivityDialog;
                dialog.clear();
                dialog.setVisible(true);
                try{
                    dialog.loadCouponActivitys();
                }catch(err){
                    this.errMsg("错误","加载券活动发生错误："+err.message);
                    return;
                }
            },

            couponActivitySelected(params){
                let selectdActivitys = params.selectedActivitys;
                this.billData.couponActivitys = selectdActivitys;

                this.selectCouponActivityTab();
            },
            clear(){
                this.billData = this.getBill().getEmptyData();
            },

            //--need implement--
            setState(state){
                this.editorState = state;
            },
            async printCouponAction(){
                let me = this;
                me.printing  = true;
                setTimeout(function(){me.printing=false;},5000);
                try{
                    let backendPrint = await this.printCouponRemote();
                    me.getMessageDialogHelper().infoMsg('成功','补打请求已发送');
                    me.reload(me.billData.id);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','补打请求异常:'+err.message);
                    return;
                }
            },
            async printCouponRemote(){
                let me = this;
                let bill={};
                
                bill.printId = this.billData.id; 

                let backendReprintResp = await BackendPrintApi.backendReprint(bill);
                console.log("backendReprint  returned;");

                console.log(backendReprintResp);
                
                let data = backendReprintResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'补打券异常':msg;
                    if(data.msg_detail)
                        msg = msg+","+data.msg_detail;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.backendPrint)){
                    throw new Error('补打券异常(无会话数据)');
                    return;
                }
                let backendPrint = data.data.backendPrint;
                
                //this.checkSaleHeadData(saleHead);
                return backendPrint;

            },

            async loadDataRemote(id){
                let me = this;
                console.log(" loadDataRemote backendPrintApi ");
                console.log(id);
                let getBackendPrintResp = await BackendPrintApi.getBackendPrint({id:id});
                console.log("load backendprint returned;");

                console.log(getBackendPrintResp);
                
                let data = getBackendPrintResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取券补打请求信息失败':msg;
                    if(data.msg_detail)
                        msg = msg+data.msg_detail;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.backendPrint)){
                    throw new Error('获取券补打请求信息失败(无会话数据)');
                    return;
                }
                let backendPrint = data.data.backendPrint;
                
                this.transformRemoteRec(backendPrint);
                return backendPrint;
            },
            transformRemoteRec(backendPrint){
                backendPrint.giveCoupons = backendPrint.couponActivityRecords;
                backendPrint.giveStamps = backendPrint.stampRecords;
                if(backendPrint.giveCoupons && backendPrint.giveCoupons.length && backendPrint.giveCoupons.length>0){
                    backendPrint.gived = 1;
                }else if (backendPrint.giveStamps && backendPrint.giveStamps.length && backendPrint.giveStamps.length>0){
                  backendPrint.gived = 1;
                } else{
                    backendPrint.gived = 0;
                }
            },
            //回调注意传入单据数据信息
            async  loadData(billInfo,loadRemote,loadSuccessCallback,loadFailCallback){
                console.log("backendprint coupon loadData");
                console.log(billInfo);
                let me = this;
                this.clear();
                if(billInfo.id==-1){
                    this.billData = billInfo;
                }else if(!loadRemote){
                    this.billData = billInfo;
                }else{
                    let backendPrint=null;
                    //远程加载
                    try{
                        backendPrint = await this.loadDataRemote(billInfo.id);
                        me.selectedAppoints=[];
                    }catch(err){
                        console.log(err);
                        me.getMessageDialogHelper().errMsg('错误','加载补打请求信息失败:'+err.message);
                        loadFailCallback(this.billData);
                        return;
				    };
                    this.billData = backendPrint;                    
                }
                loadSuccessCallback(this.billData);
                
            },
            //回调注意传入单据数据信息,建议所有持久化服务程序，执行完后在服务端立即执行查询并返回，节省一次调用
            async saveDataRemote(bill){
                let saveBackendPrintResp = await BackendPrintApi.saveBackendPrint(bill);

                console.log("save backendPrint  returned;");
                console.log(saveBackendPrintResp);  
                
                let data = saveBackendPrintResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'保存补打请求失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data) || (!data.data.backendPrint)){
                    throw new Error('保存补打请求时返回无数据');
                    return;
                }
                let backendPrint = data.data.backendPrint;      
                return backendPrint;
            },
            async saveData(saveSuccessCallback,saveFailCallback){
                let me = this;
                let bill={};
                
                bill.shopId = this.billData.shopId;
                bill.sktno = (this.billData.sktno+"").trim();
                bill.fphm = (this.billData.fphm+"").trim();
                bill.couponActivitys = this.billData.couponActivitys;
                bill.stampActivitys = this.billData.stampActivitys;

                if((!bill.shopId)||(bill.shopId=='')||(bill.shopId=='-1')){
                    me.getMessageDialogHelper().errMsg('错误','还未选择门店');
                    saveFailCallback(this.billData);
                    return;
                }
                if((bill.sktno=='')||(bill.fphm=='')){
                    me.getMessageDialogHelper().errMsg('错误','请录入收款台号和发票号码');
                    saveFailCallback(this.billData);
                    return;
                }

                
                try{    
                    if(!((this.billData.giveCoupons)&&(this.billData.giveCoupons.length)&&(this.billData.giveCoupons.length>0))){
                      if(!((this.billData.giveStamps)&&(this.billData.giveStamps.length)&&(this.billData.giveStamps.length>0))){

                        if((!bill.couponActivitys)||(!bill.couponActivitys.length)||(bill.couponActivitys.length<1)){
                          if((!bill.stampActivitys)||(!bill.stampActivitys.length)||(bill.stampActivitys.length<1)){
                            me.getMessageDialogHelper().errMsg('错误','交易还未发券，还没有合适的活动来执行发券');
                            saveFailCallback(this.billData);
                            return;
                          }
                        }

                        if(bill.couponActivitys.length>5 || bill.stampActivitys.length > 5){
                          me.getMessageDialogHelper().errMsg('错误','所选活动太多（不能超过5个）');
                          saveFailCallback(this.billData);
                          return;
                        }

                        //检测活动时间和小票时间
                        let saleHead = this.billData.saleHead;
                        let saleDate = new Date(Date.parse(saleHead.saleDate));
                        let couponActivitys = bill.couponActivitys;
                        for(let idx=0 ;idx< couponActivitys.length;++idx){
                          let couponActivity = couponActivitys[idx];
                          let startDate = new Date(Date.parse(couponActivity.startDate));
                          let endDate = new Date(Date.parse(couponActivity.endDate));
                          endDate = new Date(endDate.getTime() + 24 * 60 * 60 * 1000);
                          if(!((saleDate.getTime()>=startDate.getTime()) && (saleDate.getTime()<endDate.getTime()))){
                            me.getMessageDialogHelper().errMsg('错误','活动编号:'+couponActivity.activityId+" 和小票不在同一时间段内");
                            saveFailCallback(this.billData);
                            return;
                          }
                        }

                        let stampActivitys = bill.stampActivitys;
                        for(let idx=0 ;idx< stampActivitys.length;++idx){
                          let stampActivity = stampActivitys[idx];
                          let startDate = new Date(Date.parse(stampActivity.startDate));
                          let endDate = new Date(Date.parse(stampActivity.endDate));
                          endDate = new Date(endDate.getTime() + 24 * 60 * 60 * 1000);
                          if(!((saleDate.getTime()>=startDate.getTime()) && (saleDate.getTime()<endDate.getTime()))){
                            me.getMessageDialogHelper().errMsg('错误','印花券活动编号:'+stampActivity.activityId+" 和小票不在同一时间段内");
                            saveFailCallback(this.billData);
                            return;
                          }
                        }
                      }


                    }
                 
                    let returnedBill = await this.saveDataRemote(bill);
                    me.transformRemoteRec(returnedBill);
                    saveSuccessCallback(returnedBill);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','保存补打请求信息失败:'+err.message);
                    saveFailCallback(this.billData);
                };
                
            },
            deleteData(deleteSuccessCallback,deleteFailCallback){
                let bill={};

                deleteSuccessCallback(bill);
            },
            auditData(auditSuccessCallback,auditFailCallback){
                let bill={};

                auditSuccessCallback(bill);
            },
            cancelAuditData(cancelAuditSuccessCallback,cancelAuditFailCallback){
                let bill={};

                cancelAuditSuccessCallback(bill);
            },
            voidData(voidSuccessCallback,voidFailCallback){
                let bill={};

                voidSuccessCallback(bill);
            },
            cancelVoidData(cancelVoidSuccessCallback,cancelVoidFailCallback){
                let bill={};

                cancelVoidSuccessCallback(bill);
            },
            putOnData(putOnSuccessCallback,putOnFailCallback){
                let bill={};

                putOnSuccessCallback(bill);
            },
            withdrawData(withdrawSuccessCallback,withdrawFailCallback){
                let bill={};

                withdrawSuccessCallback(bill);
            },

            //用于指示按钮可用性,不在此
            canEdit(){
                return true;    
            },
            canDelete(){
                return false;
            },
            
            canSave(){
                return true;
            },
            canAudit(){
                return false;
            },
            canCancelAudit(){
                return false;
            },
            canVoid(){
                return false;
            },
            canCancelVoid(){
                return false;
            },
            canPutOn(){
                return false;
            },
            canWithdraw(){
                return false;
            },

            canRestore(){
                if(this.billData.status==0)
                    return true;
                return false;    
            },
            canStop(){
                if(this.billData.status==1)
                    return true;
                return false;    
            },
            
            canPrintCoupon(){
                if((this.billData)&&(this.billData.createTime)){
                    let theCreateTime = new Date(Date.parse(this.billData.createTime));
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime());
                    let endDate =  new Date(startDate.getTime() + 24 * 60 * 60 * 1000);

                    // console.log(theCreateTime+","+startDate+","+endDate);
                    // console.log(theCreateTime.getTime()+","+startDate.getTime()+","+endDate.getTime());
                    if(((theCreateTime.getTime()>=startDate.getTime()) && (theCreateTime.getTime()<endDate.getTime())&&(!this.printing))){
                        return true;
                    }
                }
                return false;
            },

            getGivedName(){
                if(this.billData && this.billData.gived){
                    if(this.billData.gived==0)
                        return "未生成券";
                    else if(this.billData.gived==1)
                        return "已生成券";
                    return "";
                }
                return "";
            },
        },
        created(){
            console.log("user Editor created");
            this.billData = this.getBill().getEmptyData();
            this.initSignals();
        },
        mounted(){ 
            console.log("user Editor mounted");
            if(!this.billData)
                this.billData = this.getBill().getEmptyData();
        },
    }
</script>

<style scoped>
    .readonly_input_item{
		background-color:lightgrey;
	}
	.careful_input_item{
		background-color:lightblue;
	}

    .table-title{
        background-color:lightblue;
        color:black;
    }

    .table-title-container{
        border-bottom: solid 2px lightblue;
    }

    .dash-line{
        border-top:1px dashed #333333;
	}
    .active-tab-view{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
        overflow-y: auto;
        overflow-x: hidden;
	}
	
	.tabViewContainer{
        /*
		overflow: scroll;
		width:100%;
		height:100%;
        */
        visibility: inherit;
	}
	.active-tab{
		background-color: lightblue;
	}

    .v-tabitem-group {
		border-top:2px solid lightblue;
		padding-top: 10px;
	}

    .tabPane-root{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
	}

    .queryResultPaneRoot{
        position:absolute;
        left:0px;
        top:0px;
        bottom: 0px;
        right:0px;
        overflow-y: hidden;
    }

    .result-table{
        width:100%;
        height:100%;
    }

</style>
